import type { YearContext } from "../../models/yearContext";
import { DataTable, type DataTableProps } from "../datatable/DataTable";
import { StatusIndicator } from "../indicator/StatusIndicator";

type YearContextsTableProps = {
  years: YearContext[];
} & Required<Pick<DataTableProps<YearContext>, "onEdit" | "onDelete" | "onSortStatusChange" | "sortStatus" | "fetching">>;

export function YearContextsTable({ years, ...props }: YearContextsTableProps) {
  return (
    <DataTable
      canDelete={(row) => !row.current}
      records={years}
      columns={[
        {
          accessor: "starts_at",
          title: "Beginnt",
          sortable: true,
          width: "40%",
        },
        {
          accessor: "ends_at",
          title: "Endet",
          sortable: true,
          width: "40%",
        },
        {
          accessor: "current",
          title: "Aktives Jahr",
          width: "0%",
          render: (year) => <StatusIndicator active={year.current} />,
        },
      ]}
      {...props}
      pagination={undefined as never}
      onPageChange={undefined as never}
    />
  );
}
